<template>
  <div>
    <ProductsDisplay v-if="recommendedProducts && this.$store.getters.getFeaturedProducts && this.$store.getters.getFeaturedProducts.length > 0 && !this.$store.getters.getSearchMode"
      :isLoading="$store.state.isLoading" :products="this.$store.getters.getFeaturedProducts"
      :title="translations.recommended" :prefix="'featured_'" :placeholderCount="1" :isCarousel="false" />

    <Title v-if="titleInUse()" :title="title" :description="description" />

    <ProductsPagination v-if="hasProducts() || $store.state.view.isLoading || $store.state.view.isLoadingProducts" :isLoading="$store.state.isLoading">
      <ProductsLayout />
    </ProductsPagination>
    <Subcategories v-else="" :subcategories="getSubcategories()"/>
  </div>
</template>

<script>
import ProductsPagination from '@/layouts/archive/pagination/Pagination.vue';
import ProductsLayout from '@/layouts/archive/product-grid/ProductsLayout.vue';
import Subcategories from '@/layouts/archive/subcategories-grid/Subcategories.vue';
import ProductsDisplay from '@/layouts/single/ProductsDisplay.vue';
import Title from '@/layouts/general-ui/Title.vue';
import qs from "qs";

export default {
  components: {
    ProductsPagination,
    ProductsLayout,
    ProductsDisplay,
    Title,
    Subcategories
  },
  data() {
    return {
      recommendedProducts: ws_vue_store.archive_featured_products === '1',
      archiveTitle: ws_vue_store.archive_title === '1',
      title: '',
      description: '',
      subcategories: [],
      translations: {
        recommended: ws_vue_store.translations.recommended_products,
        archiveTitle: ws_vue_store.translations.archive_title,
        searchFor: ws_vue_store.translations.search_for,
        discountedProductsTitle: ws_vue_store.translations.discounted_products_page_title,
        newProductsPageTitle: ws_vue_store.translations.new_products_page_title
      }
    };
  },
  methods: {
    titleInUse() {
      const setCategory = this.getCurrentCategoryID();
      if (setCategory) {
        const foundCategory = this.$store.state.categories.find(
          category => category.term_id == setCategory
        );
        if (foundCategory) {
          this.title = foundCategory.name;
          this.description = foundCategory.description;
        } else {
          return false;
        }
      } else if (this.archiveTitle && !this.$store.getters.getSearchMode) {
        this.title = this.translations.archiveTitle;
        this.description = '';
      } else if (this.$store.getters.getSearchMode && this.$store.state.filters.keyword != '') {
        this.title = this.translations.searchFor + ' ' + this.$store.state.filters.keyword;
        this.description = '';
      } else if (this.$store.getters.isDiscountedProductsPage) {
        this.title = this.translations.discountedProductsTitle;
        this.description = '';
      } else if (this.$store.getters.isNewProductsPage) {
        this.title = this.translations.newProductsPageTitle;
        this.description = '';
      } else {
        return false;
      }
      return true;
    },
    getCurrentCategoryID() {
      if (
        this.$store.state.filters.current
        && this.$store.state.filters.current.product_cat
        && this.$store.state.filters.current.product_cat.length
      ) {
        return this.$store.state.filters.current.product_cat[0];
      }
      return 0;
    },
    getSubcategories() {
      const currentCategoryID = this.getCurrentCategoryID();
      if (currentCategoryID) {
        return this.$store.state.categories.filter(
          category => category.parent == currentCategoryID
        );
      }
      return [];
    },
    hasProducts() {
      return this.$store.state.products && this.$store.state.products.length > 0 || this.$store.getters.getFeaturedProducts && this.$store.getters.getFeaturedProducts.length > 0;
    }
  },
  computed: {
  }
};
</script>
